import axios, { AxiosInstance, AxiosResponse } from 'axios'
import { CMDTYPES } from 'src/types/cmdtype'
import { RequestDataType, RequestHeaderType, ResponseDataType } from 'src/types/api'
import { gri } from 'src/service/utils'
import { captureServerError, captureUnexpectedErrCode } from 'src/service/utils/sentry/api'
import { addApiBreadcrumb } from 'src/service/utils/sentry/breadcrumbs'
import { ERRCODE_SUCCESS } from 'src/types/errcodes'

const RequestID = gri()

export class HttpData<T> {
  Header: RequestHeaderType
  Body?: T

  constructor(CmdType: CMDTYPES, Body?: T) {
    this.Header = { RequestID: RequestID, CmdType: CmdType }
    this.Body = Body
  }
}

const httpData = <T>(Cmdtype: number, Body?: T): RequestDataType<T> => {
  return new HttpData(Cmdtype, Body)
}

class CustomAxios {
  private axiosInstance: AxiosInstance
  private readonly baseURL: string

  constructor() {
    this.baseURL = process.env.REACT_APP_SERVER_BASE_URL as string
    // this.baseURL = 'https://wcrs.couponwallet.co.kr/partner'
    this.axiosInstance = axios.create({
      baseURL: this.baseURL,
    })

    // 응답 인터셉터 설정
    this.axiosInstance.interceptors.response.use(
      (response) => {
        if (response.status === 204) {
          window.location.reload()
          alert('잘못된 요청입니다. 다시 시도해주세요.')
        }
        return response.status !== 200 ? new Promise(() => {}) : response
      },
      (error) => {
        return Promise.reject(error)
      },
    )
  }

  //T : request Body Type
  //U : response Body Type
  async post<T, U>(CmdType: number, Body?: T): Promise<ResponseDataType<U>> {
    addApiBreadcrumb('request', { cmdType: String(CmdType) })

    try {
      return await this.axiosInstance
        .post('', JSON.stringify(httpData<T>(CmdType, Body)), { withCredentials: true })
        .then((res: AxiosResponse<ResponseDataType<U>>) => {
          const data = res.data
          if (data.Header.ErrCode !== ERRCODE_SUCCESS) {
            addApiBreadcrumb('response', {
              cmdType: String(CmdType),
              errCode: String(data.Header.ErrCode),
              errMsg: data.Header.ErrMsg,
            })
          }
          captureUnexpectedErrCode(data.Header)
          return data
        })
    } catch (error) {
      captureServerError(error, CmdType)
      console.error('Error POST request:', error)
      throw error
    }
  }
}

export const fetch = new CustomAxios()
